module.exports = __webpack_public_path__ + "static/img/record.58f55c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/record.png
// module id = 2kvD
// module chunks = 6